var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4u9my9toia",
    d: "M0 0.049L20.39 0.049 20.39 10.8 0 10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ft71dx3u9c",
    d: "M0 0.415L20.013 0.415 20.013 15.078 0 15.078z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.686)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "owilyqvo0b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4u9my9toia"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M19.636.049H.794C.418.049.07.302.01.666c-.078.465.285.868.742.868H8.09v8.571c0 .384.316.695.706.695h2.539c.39 0 .705-.311.705-.695V1.534h7.557c.375 0 .723-.253.784-.619.076-.464-.287-.866-.744-.866",
    mask: "url(#owilyqvo0b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .486)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qqed2csi3d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ft71dx3u9c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M19.207 4.699H18.01l-1.295-2.882C15.94.746 15.37.415 14.438.415H5.716c-.931 0-1.5.331-2.277 1.402L2.144 4.699H.81c-.528 0-.944.505-.77.996.115.328.465.615 1.329.636l-.7 1.657c.026 2.117.026 4.208.026 6.3 0 .434.361.79.802.79h2.666c.444 0 .803-.354.803-.79v-1.735h10.197v1.734c0 .435.36.79.802.79h2.692c.43 0 .776-.342.776-.765 0-2.1.026-4.199.026-6.324l-.699-1.657c.3-.008.54-.046.73-.108.844-.271.606-1.524-.283-1.524M4.552 2.76c.284-.484.595-.918 1.164-.968h8.722c.57.05.88.484 1.165.968.517 1.02.905 1.939 1.32 2.832H3.232c.414-.893.802-1.811 1.32-2.832",
    mask: "url(#qqed2csi3d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M7.25 9.749h5.487c.336 0 .595.28.595.612 0 .306-.259.587-.595.587H7.25c-.31 0-.595-.281-.595-.587 0-.331.285-.612.595-.612m9.213-1.122c-.698 0-1.293.561-1.293 1.275 0 .688.595 1.275 1.293 1.275.726 0 1.295-.587 1.295-1.275 0-.714-.57-1.275-1.295-1.275m-12.914 0c.699 0 1.295.561 1.295 1.275 0 .688-.596 1.275-1.295 1.275-.724 0-1.294-.587-1.294-1.275 0-.714.57-1.275 1.294-1.275"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarage);
export default __webpack_public_path__ + "static/media/garage.e66944e59c0721ef38c46aad985b129b.svg";
export { ForwardRef as ReactComponent };